<template>
  <v-dialog v-model="showDialog" width="500" v-on:click:outside="onClose">
    <v-card class="non-unique-modal">
      <v-card-title>
        <div />
        <h2>Uh-oh.</h2>
        <button @click="onClose">
          <v-icon>mdi-close</v-icon>
        </button>
      </v-card-title>
      <p>It looks like {{username}} is linked to an existing ASCA web account. Please enter a unique username to continue setting up your account.</p>
      <p>If you are attempting to create a new web account and previously used this email, please contact the ASCA Business Office at <a href="mailto:support@asca.org">support@asca.org</a>.</p>
      <v-text-field
        outlined
        required
        label="Username"
        type="text"
        v-model="newUsername"
        :rules="[(v) => !!v || 'Username is required']"
      ></v-text-field>
      <v-btn
        :dark="!!newUsername"
        large
        color="primary"
        v-on:click="onCheck(newUsername)"
        :disabled="!newUsername"
      >Next</v-btn>
      <p v-if="!loggedIn">Already have an account? <a href="/login">Login</a></p>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'UniqueUsernameDialog',
  props: {
    showDialog: {type: Boolean},
    onClose: {type: Function},
    onCheck: {type: Function},
    username: {type: String},
    loggedIn: {type: Boolean},
  },
  data() {
    return {
      newUsername: '',
    }
  },
});
</script>